export const accountNotFoundErrorMessage = () => `Account number not found.`;
export const billingNumberNotFoundErrorMessage = () => `Auto Inserted Billing number not found.`;
export const invalidBillingNumberErrorMessage = () => `Invalid Auto Inserted Billing number.`;
export const invalidAccountNumberErrorMessage = () => `Invalid Account Number`;
export const accountNotFoundErrorKey =()=> 'error_account_not_found'
export const billingNumberNotFoundErrorKey =()=> 'error_billing_number_not_found'
export const accountGenericErrorKey =()=> 'error_generic'